import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { GroupOrderType } from './group-order-types.interfaces';

@Injectable({
  providedIn: 'root',
})

/**
 * GroupTypes REST calls
 */
export class GroupOrderTypesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all group types
   */
  getGroupTypes(): Observable<GroupOrderType[]> {
    const url = `${this.globals.apiRoot}/jwtgroupordertypes`;
    return this.http.get<GroupOrderType[]>(url);
  }
}
